export default {
  Client: 1,
  Department: 2,
  Legal: 3,
  IP: 4,
  OwnLegal: 5,
  PrivatePerson: 6,
} as const;
